import GameObject from '../../GameObject/GameObject';
import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import Interactable from '../../Component/Interactable';
import Game from '../../Game';
import Text from '../Text';
import { applyDefaultButtonAnimation } from '../../System/UI/UIHelper';

export default class HelperFriend extends GameObject {
    public static BASE: string = 'base';
    public static AVATAR: string = 'avatar';
    public static BUTTON: string = 'button';

    private lightPositions: Point[] = [
        new Point(-92, -86),
        new Point(-92, -62),
        new Point(-92, -37),
        new Point(-92, -12),
        new Point(90, -86),
        new Point(90, -62),
        new Point(90, -37),
        new Point(90, -12),
    ];

    public onCreate(params: any) {
        this.name = params.name || 'helper_friend';

        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, {
            alpha: 0,
        });

        const avatar: Sprite = GameObject.Instantiate(Sprite, {
            name: HelperFriend.AVATAR,
            texture: 'blank',
            anchor: new Point(0, 0),
            y: -152,
            x: -86,
            width: 60,
            height: 60,
        });
        this.addChild(avatar);

        // Add the base sprite.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            name: HelperFriend.BASE,
            texture: 'base_content',
            anchor: new Point(0.5, 1),
        });

        this.addChild(baseSprite);

        // Create lights
        this.lightPositions.forEach((position: Point, index: number) => {
            const lightSprite: Sprite = GameObject.Instantiate(Sprite, {
                name: `light_${index}`,
                texture: 'light_small_1',
                anchor: new Point(0.5, 0.5),
                position,
            });
            baseSprite.addChild(lightSprite);
        });

        // Create button
        const buttonBg: GameObject = GameObject.Instantiate(Sprite, {
            name: 'button_bg',
            texture: 'blank',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0.75, 0.75),
            y: -40,
        });

        const button: GameObject = GameObject.Instantiate(Sprite, {
            name: HelperFriend.BUTTON,
            texture: 'friend_helper_button',
            anchor: new Point(0.5, 0.525),
            scale: new Point(1.3, 1.3),
        });

        const buttonText: GameObject = GameObject.Instantiate(Text, {
            name: 'button_text',
            text: Game.locale.getText('Accept'),
            style: {
                ...Game.style.getStyle('popup.green_btn'),
                lineHeight: 0,
                fontSize: 40,
            },
            anchor: new Point(0.5, 0.6),
            bounds: new Point(125, 45),
        });
        buttonBg.addChild(button);
        button.addChild(buttonText);
        baseSprite.addChild(buttonBg);

        button.addComponent(Interactable, {
            enabled: true,
            buttonMode: true,
        });
        applyDefaultButtonAnimation(button);

        // Create arrow
        const arrow: GameObject = GameObject.Instantiate(Sprite, {
            name: 'arrow',
            texture: 'arrow',
            anchor: new Point(0.5, 0.5),
            y: -130,
            x: 30,
        });
        baseSprite.addChild(arrow);

        const cardIcon: GameObject = GameObject.Instantiate(Sprite, {
            name: 'card_icon',
            texture: '3cards',
            anchor: new Point(0.5, 0.5),
            x: -15,
            y: -5,
        });
        arrow.addChild(cardIcon);
    }
}
